module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-precomposed-b1759a89c92218c978bb1e2a5d5e6475.png";